import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptor } from "src/utils/baseQuery";
export const DashboardApi = createApi({
  reducerPath: "DashboardApi",
  baseQuery: baseQueryWithInterceptor,
  tagTypes: ["Dashboard"],
  endpoints: (builder) => ({
    getPeriodicOrderCount: builder.query<any, string>({
      query: (type) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `dashboard/periodic-data?type=${type}`,
        method: "GET",
      }),
    }),
    getOrderCountByType: builder.query<any, string>({
        query: (type) => ({
          headers: {
            "Content-type": "application/json",
          },
          url: `dashboard/count/${type}`,
          method: "GET",
        }),
      }),

      getOrderCountByEmirates: builder.query<any, string>({
        query: (type) => ({
          headers: {
            "Content-type": "application/json",
          },
          url: `dashboard/emirate-order-count?type=${type}`,
          method: "GET",
        }),
      }),

      getLastLocation: builder.query<any, { entity?: string }>({
        query: ({ entity } = {}) => ({
          headers: {
            "Content-type": "application/json",
          },
          url: `dashboard/last-location?limit=1000&page=1${entity ? `&entity=${entity}` : ""}`,
          method: "GET",
        }),
      }),
  }),
});

export const { useGetPeriodicOrderCountQuery, useGetOrderCountByTypeQuery, useGetOrderCountByEmiratesQuery, useGetLastLocationQuery } = DashboardApi;